import { FindCollectionsToOfflineOutput } from '../../../../../../../../../services/modules/collections/collections.types';
import { OfflineDatabaseCollection } from '../../../../../../../database/offlineDatabase/types/offlineDatabaseCollection.types';
import { offlineCollectionsRepository } from '../../../../../../../repositories/offlineCollections.repository';
import { QueryKeysAndFnOptions } from '../../../useQueryKeysAndFnToCache.types';
import { generateQueryKeysAndFnToPaginatedEndpoint } from '../../generateQueryKeysAndFnToPaginatedEndpoint';
import { QueryKeysAndFnGenerator, QueryKeysAndFnGeneratorParams } from './types';

export class CollectionsQueryKeysAndFnGenerator implements QueryKeysAndFnGenerator {
  constructor(private readonly params: Pick<QueryKeysAndFnGeneratorParams, 'priority'>) {}

  async generateQueryKeysAndFn(): Promise<QueryKeysAndFnOptions> {
    return generateQueryKeysAndFnToPaginatedEndpoint<FindCollectionsToOfflineOutput>({
      url: '/collections/offline/v1',
      priority: this.params.priority,
      fnToSaveData: async (data) => {
        await offlineCollectionsRepository.saveAll(data.map(this.toOfflineData));
      },
    });
  }

  private toOfflineData(data: FindCollectionsToOfflineOutput): OfflineDatabaseCollection {
    return {
      id: data.id,
      code: data.code,
      name: data.name,
    };
  }
}
